<template>
  <div>
     <Search />
     <SearchById />
  </div>
</template>

<script>
import Search from '@/components/AssignmentTermsSearch/Search'
import SearchById from '@/components/AssignmentTermsSearch/SearchById'

export default {
  name: 'AssignmentTermsDashboard',
  components: {
    Search,
    SearchById
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
